import validator from 'validator';

const validators = {
    name: (val) => {
        if (!val) {
            return 'contact-required-field-error';
        }
        return null;
    },
    email: (val) => {
        if (!val) {
            return 'contact-required-field-error';
        } else if (!validator.isEmail(val)) {
            return 'contact-invalid-email-error';
        }
        return null;
    },
    phone: (val) => {
        if (!val) {
            return 'contact-required-field-error';
        } else if (!validator.isMobilePhone(val)) {
            return 'contact-invalid-phone-error';
        }
        return null;
    },
    message: (val) => {
        if (!val) {
            return 'contact-required-field-error';
        } else if (val.length < 10) {
            return 'contact-invalid-message-error';
        }
        return null;
    },
};

export default validators;
